//#region Images
import errorImage1 from "img/error_image_1.svg";
//#endregion
//#region Utils
import { RESOURCES_CONSTANTS } from "config/constants";
//#endregion

export const INIT_FORM = {
    id: "",
    campusId: 0,
    libraryId: 0,
    resourceTypeId: 0,
    name: "",
    capacity: "",
    screenId: 0,
    groupRoomOutOfLibrary: false,
    environment: "",
    address: "",
    details: "",
    active: true
};
export const INIT_ERRORS_FORM = {
    capacity: false
};
export const INIT_ERROR_TEXTS_FORM = {
    capacity: ""
};
export const ERROR_TEXT_LIST = {
    MINIMUM_OF_STUDENTS: "Es necesario indicar el número de alumnos",
    SCREEN: "Es necesario seleccionar una pantalla",
    CAPACITY: {
      INVALID_FOR_FUTURE_RESERVATIONS: "Actualmente hay reservas vigentes o futuras",
      INVALID_FOR_LESS_THAN_2: "La cantidad debe ser 2 o más"  
    }
};
export const ERROR_MESSAGES_IN_UPDATE_RESOURCE_REQUEST = {
    FUTURE_RESERVATIONS: "RESERVAS_FUTURAS"
};
export const PROPS_CONTENT_DIALOG_ALERT_NOT_UPDATE_FOR_FUTURE_RESERVATION_WHEN_CHANGES_CAPACITY = {
    image: <img src={errorImage1} alt="Imagen error en UTP"/>,
    paddingTop: "40px",
    title: "No se puede editar la sala grupal",
    value: "Actualmente la sala grupal cuenta con una reserva, para editar la capacidad máxima de alumnos, debes validar que no exista ninguna reserva vigente o futura.",
};
export const GROUP_ROOM_SERVICE_TYPE_ID = RESOURCES_CONSTANTS.RESOURCE_TYPES_IDS.GROUP_ROOM;